import { Typography } from '@mui/material';
import React from 'react';
import HdDocLink from '../../../../../docs/components/doc-link/HdDocLink';
import { SelectionDestinationTypeHeaderType } from '../../interfaces/selectDestinationType';
import styles from './SelectDestinationTypeHeader.module.scss';

interface HeaderProps {
  docLink?: string;
  headerType: SelectionDestinationTypeHeaderType;
  destinationKeyword: string;
}

export default function SelectDestinationTypeHeader({
  docLink,
  headerType,
  destinationKeyword
}: HeaderProps) {
  return (
    <div className={`header-container ${styles.headerWrapper}`}>
      {headerType === SelectionDestinationTypeHeaderType.ADD_DESTINATION ? (
        <>
          <Typography variant='h3' component='h3'>
            Add Destination
          </Typography>

          <Typography component='span' className={styles.linkHolder}>
            A Destination is a data warehouse that stores all your data.{' '}
            {docLink ? (
              <HdDocLink
                docLink={docLink}
                section='select_destination_type'
                dataId='destination'
              />
            ) : null}
          </Typography>
        </>
      ) : null}

      {headerType === SelectionDestinationTypeHeaderType.SELECT_DESTINATION_TYPE ? (
        <>
          <Typography variant='h3' component='h3'>
            Select {destinationKeyword} Type
          </Typography>

          <Typography component='span' className={styles.linkHolder}>
            Select the {destinationKeyword} Type to move your data.
          </Typography>
        </>
      ) : null}
    </div>
  );
}
